export default __webpack_public_path__ + "static/professional-beauty-496cc803c4d8e30ac646bf2f7ec7af8e.svg";